import React from 'react';
// @ts-ignore - The type declarations for the Button component are not being recognized
import { Button } from 'theme-ui';
import ChevronDown from '~/assets/images/icons/chevron-down.svg';

type Props = {
  title: string | null;
  onClick: () => void;
  isOpen: boolean;
};

const DropdownButton = ({ title, onClick, isOpen }: Props) => {
  return (
    <Button
      onClick={onClick}
      variant="bare"
      sx={{
        fontFamily: 'primary',
        fontWeight: 'medium',
        textTransform: 'uppercase',
        display: 'flex',
        alignItems: 'center',
        gap: '0.8rem',
        svg: {
          transition: 'transform 0.2s ease-in-out',
          transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
        },
        WebkitTapHighlightColor: 'transparent',
      }}
    >
      <div
        // Empty div to center the text
        sx={{
          width: '2.4rem',
          height: '2.4rem',
        }}
      />
      <span>{title}</span>
      <ChevronDown />
    </Button>
  );
};

export default DropdownButton;
